// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box[data-v-f8dda67e] .el-select .el-input {\n  width: 110px;\n}\n.input-with-select[data-v-f8dda67e] .el-input-group__prepend {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
